import { createSlice } from "@reduxjs/toolkit";
import {
  insertCertificate,
  GetCertificate,
  deleteCertificate,
} from "../api/CertificateApi";

const initialState = {
  CertificateData: {},
  loading: false,
};

export const CertificateSlice = createSlice({
  name: "CertificateSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(insertCertificate.pending, (state) => {
        state.loading = true;
      })
      .addCase(insertCertificate.fulfilled, (state, action) => {
        // state.CertificateData = action.payload.data;
        state.loading = false;
      })
      .addCase(insertCertificate.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(GetCertificate.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetCertificate.fulfilled, (state, action) => {
        state.CertificateData = action.payload;

        state.loading = false;
      })
      .addCase(GetCertificate.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(deleteCertificate.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCertificate.fulfilled, (state, action) => {
        state.loading = false;
        const deletedId = action.meta.arg.id; // Get ID from the action
        state.CertificateData.result = state.CertificateData.result.filter(
          (cert) => cert.id !== deletedId
        );
      })
      .addCase(deleteCertificate.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default CertificateSlice.reducer;
